import { useMemo } from 'react'
import { Flexbox } from '@/components/ui/flexbox'
import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'
import {
	OpsVettingGalleryGrid,
	OpsVettingGalleryItemsContainer,
	OpsVettingSectionWrapper
} from '@/features/ops-vetting/components/ops-vetting-atoms'

export const ServiceVettingCriteriaGallerySkeleton = () => {
	// Generate an array of items for the skeleton
	const skeletonItems = useMemo(
		() => Array.from({ length: 7 }, (_, i) => `skeleton-${i}`),
		[]
	)

	return (
		<OpsVettingSectionWrapper direction='column' fullWidth gap={6}>
			{/* Header section */}
			<Flexbox align='center' fullWidth justify='space-between'>
				<Flexbox align='center' gap={8}>
					{/* Title skeleton */}
					<Skeleton height={24} width={180} />

					{/* Upload button skeleton */}
					<Skeleton height={36} width={120} />

					{/* Checkbox skeletons */}
					<Flexbox align='center' gap={2}>
						<Skeleton height={20} width={20} />
						<Skeleton height={20} width={150} />
					</Flexbox>

					<Flexbox align='center' gap={2}>
						<Skeleton height={20} width={20} />
						<Skeleton height={20} width={180} />
					</Flexbox>
				</Flexbox>

				{/* Status section */}
				<Skeleton height={20} width={140} />
			</Flexbox>

			<Separator orientation='horizontal' />

			{/* Gallery grid */}
			<OpsVettingGalleryGrid>
				{/* Cover photo skeleton (first item, slightly different) */}
				<OpsVettingGalleryItemsContainer direction='column' gap={4}>
					<Skeleton
						height='100%'
						style={{ borderRadius: '8px', aspectRatio: '1/1' }}
						width='100%'
					/>
					<Flexbox direction='column' fullWidth gap={2}>
						<Skeleton height={18} width='70%' />
					</Flexbox>
				</OpsVettingGalleryItemsContainer>

				{/* Regular gallery items */}
				{skeletonItems.map((key) => (
					<OpsVettingGalleryItemsContainer
						direction='column'
						gap={4}
						key={key}
					>
						<Skeleton
							height='100%'
							style={{ borderRadius: '8px', aspectRatio: '1/1' }}
							width='100%'
						/>
						<Flexbox direction='column' fullWidth gap={2}>
							<Skeleton height={18} />
							<Flexbox gap={2}>
								<Skeleton height={38} />
								<Skeleton height={38} />
							</Flexbox>
						</Flexbox>
					</OpsVettingGalleryItemsContainer>
				))}
			</OpsVettingGalleryGrid>
		</OpsVettingSectionWrapper>
	)
}
